import React from 'react'
import { Chart, registerables } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import * as styles from './styles.module.scss'

Chart.register(ChartDataLabels, ...registerables)

Chart.defaults.set('plugins.datalabels', {
	anchor: 'end',
	align: 'end',
	font: {
		size: 18,
		weight: 'bold'
	},
	textAlign: 'center'
})

interface BarChartProps {
	data: Array<{
		category: string
		value: number
		label: string
	}>
	formatter?: (value: any) => any
}

const BarChart: React.FC<BarChartProps> = ({ data, formatter }) => {
	return (
		<Bar
			className={styles.chart}
			options={{
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: false
					},
					tooltip: {
						enabled: false
					},
					datalabels: {
						formatter:
							formatter ??
							((value) => {
								return `${value / 1000000} mil.`
							})
					}
				},
				layout: {
					padding: {
						top: 30,
						left: 0,
						right: 0,
						bottom: 30
					}
				},
				animation: {
					duration: 3000,
					delay: 1000
				},
				scales: {
					xAxis: {
						grid: {
							display: false,
							borderWidth: 0
						},
						ticks: {
							font: {
								size: 18
							},
							padding: 10
						}
					},
					yAxis: {
						display: false
					}
				}
			}}
			data={{
				labels: data.map((item) => item.category),
				datasets: [
					{
						xAxisID: 'xAxis',
						yAxisID: 'yAxis',
						data: data.map((item) => item.value),
						backgroundColor: ['#9B9B9B', '#5B5B5B', '#000000', '#DC0069'],
						borderWidth: 0
					}
				]
			}}
		/>
	)
}

export default BarChart
